import { ContentImg } from './styles'
import PropTypes from 'prop-types'
const ImgPreviewObt = ({ device, imgUrl }) => {
    return (
        <ContentImg device={device} displayN={2}>
            <svg version="1.1" id="condolence-imagen-message" xmlns="http://www.w3.org/2000/svg" xmlnsXlink="http://www.w3.org/1999/xlink" x="0px" y="0px"
                viewBox="0 0 848.2 512.4"
                enable-background="new 62 -3.2 424.1 256.2"
                xmlSpace="preserve">
                <image
                    width="100%"
                    height="100%" overflow="visible" xlinkHref={imgUrl}>
                </image>
            </svg>
        </ContentImg>
    )
}
ImgPreviewObt.propTypes = {
    imgIcon: PropTypes.string,
    img: PropTypes.string,
    imgUrl: PropTypes.string,
    transform: PropTypes.string,
    device: PropTypes.string,
}

export default ImgPreviewObt;